// removed by extract-text-webpack-plugin
module.exports = {"form":"_1435Vbmjok","required":"_2wRvVLn-d4","wrapper":"_1-5Ks5fP0q wrapper","emailConsentHeader":"_1zVw88CLPb label"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/Registration/Registration.module.less
// module id = 479
// module chunks = 3